import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionHandlingService {

  public data: Subject<any> = new Subject();
  // tslint:disable-next-line:variable-name
  private _permissionsMap = new Map(); // for the future dynamic permissions setter
  public get permissionsMap() {
    return this._permissionsMap;
  }
  public set permissionsMap(value) {
    this._permissionsMap = value;
  }
  // tslint:disable-next-line:variable-name
  private _permissionsList = [];
  public get permissionsList() {
    return this._permissionsList;
  }
  public set permissionsList(value) {
    this._permissionsList = value;
  }

  // tslint:disable-next-line:variable-name
  private _siRead = false;
  public get siRead() {
    return this._siRead;
  }
  public set siRead(value) {
    this._siRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _phRead = false;
  public get phRead() {
    return this._phRead;
  }
  public set phRead(value) {
    this._phRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _dmRead = false;
  public get dmRead() {
    return this._dmRead;
  }
  public set dmRead(value) {
    this._dmRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _psRead = false;
  public get psRead() {
    return this._psRead;
  }
  public set psRead(value) {
    this._psRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _ptRead = false;
  public get ptRead() {
    return this._ptRead;
  }
  public set ptRead(value) {
    this._ptRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _pmRead = false;
  public get pmRead() {
    return this._pmRead;
  }
  public set pmRead(value) {
    this._pmRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _paRead = false;
  public get paRead() {
    return this._paRead;
  }
  public set paRead(value) {
    this._paRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _csRead = false;
  public get csRead() {
    return this._csRead;
  }
  public set csRead(value) {
    this._csRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _rsRead = false;
  public get rsRead() {
    return this._rsRead;
  }
  public set rsRead(value) {
    this._rsRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _ncsRead = false;
  public get ncsRead() {
    return this._ncsRead;
  }
  public set ncsRead(value) {
    this._ncsRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _ncpRead = false;
  public get ncpRead() {
    return this._ncsRead;
  }
  public set ncpRead(value) {
    this._ncpRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _npaRead = false;
  public get npaRead() {
    return this._npaRead;
  }
  public set npaRead(value) {
    this._npaRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _ndiRead = false;
  public get ndiRead() {
    return this._ndiRead;
  }
  public set ndiRead(value) {
    this._ndiRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _fdmRead = false;
  public get fdmRead() {
    return this._fdmRead;
  }
  public set fdmRead(value) {
    this._fdmRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _slaRead = false;
  public get slaRead() {
    return this._slaRead;
  }
  public set slaRead(value) {
    this._slaRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _dashboardRead;
  public get dashboardRead() {
    return this._dashboardRead;
  }
  public set dashboardRead(value) {
    this._dashboardRead = value;
  }
  // tslint:disable-next-line:variable-name
  private _midRead = false;
  public get midRead() {
    return this._midRead;
  }
  public set midRead(value) {
    this._midRead = value;
  }


  // divider line between read and write


  // tslint:disable-next-line:variable-name
  private _siWrite = false;
  public get siWrite() {
    return this._siWrite;
  }
  public set siWrite(value) {
    this._siWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _phWrite = false;
  public get phWrite() {
    return this._phWrite;
  }
  public set phWrite(value) {
    this._phWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _dmWrite = false;
  public get dmWrite() {
    return this._dmWrite;
  }
  public set dmWrite(value) {
    this._dmWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _psWrite = false;
  public get psWrite() {
    return this._psWrite;
  }
  public set psWrite(value) {
    this._psWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _ptWrite = false;
  public get ptWrite() {
    return this._ptWrite;
  }
  public set ptWrite(value) {
    this._ptWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _pmWrite = false;
  public get pmWrite() {
    return this._pmWrite;
  }
  public set pmWrite(value) {
    this._pmWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _paWrite = false;
  public get paWrite() {
    return this._paWrite;
  }
  public set paWrite(value) {
    this._paWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _csWrite = false;
  public get csWrite() {
    return this._csWrite;
  }
  public set csWrite(value) {
    this._csWrite = value;
  }
  // tslint:disable-next-line:variable-name
  // private _rsWrite = false;
  // public get rsWrite() {
  //   return this._rsWrite;
  // }
  // public set rsWrite(value) {
  //   this._rsWrite = value;
  // }
  // tslint:disable-next-line:variable-name
  private _ncsWrite = false;
  public get ncsWrite() {
    return this._ncsWrite;
  }
  public set ncsWrite(value) {
    this._ncsWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _ncpWrite = false;
  public get ncpWrite() {
    return this._ncpWrite;
  }
  public set ncpWrite(value) {
    this._ncpWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _npaWrite = false;
  public get npaWrite() {
    return this._npaWrite;
  }
  public set npaWrite(value) {
    this._npaWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _ndiWrite = false;
  public get ndiWrite() {
    return this._ndiWrite;
  }
  public set ndiWrite(value) {
    this._ndiWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _raWrite;
  public get raWrite() {
    return this._raWrite;
  }
  public set raWrite(value) {
    this._raWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _fdmWrite;
  public get fdmWrite() {
    return this._fdmWrite;
  }
  public set fdmWrite(value) {
    this._fdmWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _slaWrite;
  public get slaWrite() {
    return this._slaWrite;
  }
  public set slaWrite(value) {
    this._slaWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _dashboardWrite;
  public get dashboardWrite() {
    return this._dashboardWrite;
  }
  public set dashboardWrite(value) {
    this._dashboardWrite = value;
  }
  // tslint:disable-next-line:variable-name
  private _midWrite;
  public get midWrite() {
    return this._midWrite;
  }
  public set midWrite(value) {
    this._midWrite = value;
  }

  constructor() { }

  // future changeover method for dynamically creating permissions
  // would require a large change to the variable calls, possibly worth it
  createReadWritePermissions(roleList) {
    for (const detail of roleList.details) { // set all user roles
      for (const role of detail.roles) {
        this.permissionsList.push(role.rolesDesc.toUpperCase());
        this.permissionsMap.set(role.rolesDesc.toUpperCase(), true);
      }
    }
    console.log('permissions list' + JSON.stringify(this.permissionsList));
  }

}
